import { Controller } from '@hotwired/stimulus'

export default class StickyBarSpacerController extends Controller {
  static targets = ['spacer', 'bar'];

  connect() {
    this.updateSpacerHeight();
    this.resizeObserver = new ResizeObserver(() => this.updateSpacerHeight());
    this.resizeObserver.observe(this.barTarget);
  }

  disconnect() {
    this.resizeObserver?.disconnect();
  }

  updateSpacerHeight() {
    this.spacerTarget.style.height = `${this.barTarget.offsetHeight}px`;
  }
}
